import { BinaryOperator, Operator, UnaryOperator } from '../interface';

export const BINARY_OPERATORS: Record<BinaryOperator, boolean> = {
  '&&': true,
  '||': true,
  '>=': true,
  '<=': true,
  '>': true,
  '<': true,
  '===': true,
  '!==': true,
  '+': true,
  '-': true,
  '*': true,
  '/': true,
  '%': true,
  '**': true,
  '<<': true,
  '>>': true,
  '>>>': true,
  '&': true,
  '|': true,
  '^': true,
};

export const UNARY_OPERATORS: Record<UnaryOperator, boolean> = {
  '!': true,
  abs: true,
  sqrt: true,
  floor: true,
  ceil: true,
  round: true,
};

export const OPERATORS: Record<Operator, boolean> = {
  ...UNARY_OPERATORS,
  ...BINARY_OPERATORS,
};

export const OPERATOR_PRIORITY: Record<Operator, Record<Operator, boolean>> = {
  '&&': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '||': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '>=': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '<=': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '>': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '<': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '===': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '!==': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '+': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '-': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '*': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '/': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '%': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '**': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '<<': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '>>': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '>>>': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '&': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '|': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '^': {
    '&&': true,
    '||': true,
    '>=': true,
    '<=': true,
    '>': true,
    '<': true,
    '===': true,
    '!==': true,
    '+': true,
    '-': true,
    '*': true,
    '/': true,
    '%': true,
    '**': true,
    '<<': true,
    '>>': true,
    '>>>': true,
    '&': true,
    '|': true,
    '^': true,
    '!': true,
    abs: true,
    sqrt: true,
    floor: true,
    ceil: true,
    round: true,
  },
  '!': {
    '&&': false,
    '||': false,
    '>=': false,
    '<=': false,
    '>': false,
    '<': false,
    '===': false,
    '!==': false,
    '+': false,
    '-': false,
    '*': false,
    '/': false,
    '%': false,
    '**': false,
    '<<': false,
    '>>': false,
    '>>>': false,
    '&': false,
    '|': false,
    '^': false,
    '!': false,
    abs: false,
    sqrt: false,
    floor: false,
    ceil: false,
    round: false,
  },
  abs: {
    '&&': false,
    '||': false,
    '>=': false,
    '<=': false,
    '>': false,
    '<': false,
    '===': false,
    '!==': false,
    '+': false,
    '-': false,
    '*': false,
    '/': false,
    '%': false,
    '**': false,
    '<<': false,
    '>>': false,
    '>>>': false,
    '&': false,
    '|': false,
    '^': false,
    '!': false,
    abs: false,
    sqrt: false,
    floor: false,
    ceil: false,
    round: false,
  },
  sqrt: {
    '&&': false,
    '||': false,
    '>=': false,
    '<=': false,
    '>': false,
    '<': false,
    '===': false,
    '!==': false,
    '+': false,
    '-': false,
    '*': false,
    '/': false,
    '%': false,
    '**': false,
    '<<': false,
    '>>': false,
    '>>>': false,
    '&': false,
    '|': false,
    '^': false,
    '!': false,
    abs: false,
    sqrt: false,
    floor: false,
    ceil: false,
    round: false,
  },
  floor: {
    '&&': false,
    '||': false,
    '>=': false,
    '<=': false,
    '>': false,
    '<': false,
    '===': false,
    '!==': false,
    '+': false,
    '-': false,
    '*': false,
    '/': false,
    '%': false,
    '**': false,
    '<<': false,
    '>>': false,
    '>>>': false,
    '&': false,
    '|': false,
    '^': false,
    '!': false,
    abs: false,
    sqrt: false,
    floor: false,
    ceil: false,
    round: false,
  },
  ceil: {
    '&&': false,
    '||': false,
    '>=': false,
    '<=': false,
    '>': false,
    '<': false,
    '===': false,
    '!==': false,
    '+': false,
    '-': false,
    '*': false,
    '/': false,
    '%': false,
    '**': false,
    '<<': false,
    '>>': false,
    '>>>': false,
    '&': false,
    '|': false,
    '^': false,
    '!': false,
    abs: false,
    sqrt: false,
    floor: false,
    ceil: false,
    round: false,
  },
  round: {
    '&&': false,
    '||': false,
    '>=': false,
    '<=': false,
    '>': false,
    '<': false,
    '===': false,
    '!==': false,
    '+': false,
    '-': false,
    '*': false,
    '/': false,
    '%': false,
    '**': false,
    '<<': false,
    '>>': false,
    '>>>': false,
    '&': false,
    '|': false,
    '^': false,
    '!': false,
    abs: false,
    sqrt: false,
    floor: false,
    ceil: false,
    round: false,
  },
};
